import { useUpdateGoal } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { Goal } from 'shared/types/goal';
import { ContextMenuOptions } from 'shared/views/goal-filter-list/types';

export type ViewListProps = {
  goal: Goal;
  onClose: () => void;
  excludedOptions?: ContextMenuOptions[];
};

export const ViewList: React.FC<ViewListProps> = ({
  goal,
  excludedOptions,
}) => {
  const { t } = useTranslation();
  const { submit: updateGoal } = useUpdateGoal();

  const onShowRoadmapChange = (checked: boolean) => {
    updateGoal({
      id: goal.id,
      showRoadmap: checked,
    });
  };

  if (excludedOptions?.includes(ContextMenuOptions.ShowRoadmap)) {
    return null;
  }

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuToggle
          label={t('context-menus.goal.labels.show-roadmap')}
          checked={goal.showRoadmap ?? true}
          onChange={onShowRoadmapChange}
        />
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
